export const tokens = {
    // Family
    'text-font-family': 'Lato',
    'text-heading-1-font-family': '$text-font-family',
    'text-heading-2-font-family': '$text-font-family',
    'text-heading-3-font-family': '$text-font-family',
    'text-heading-4-font-family': '$text-font-family',
    'text-heading-5-font-family': '$text-font-family',
    'text-paragraph-1-font-family': '$text-font-family',
    'text-paragraph-2-font-family': '$text-font-family',
    'text-caption-1-font-family': '$text-font-family',
    'text-caption-2-font-family': '$text-font-family',
    'text-caption-3-font-family': '$text-font-family',
    // Weights
    'text-heading-1-font-size': 32,
    'text-heading-2-font-size': 24,
    'text-heading-3-font-size': 20,
    'text-heading-4-font-size': 18,
    'text-heading-5-font-size': 16,
    'text-paragraph-1-font-size': 15,
    'text-paragraph-2-font-size': 14,
    'text-caption-1-font-size': 13,
    'text-caption-2-font-size': 12,
    'text-caption-3-font-size': 8,
    // Sizes
    'text-heading-1-font-weight': 900,
    'text-heading-2-font-weight': 700,
    'text-heading-3-font-weight': 700,
    'text-heading-4-font-weight': 700,
    'text-heading-5-font-weight': 700,
    'text-paragraph-1-font-weight': 400,
    'text-paragraph-2-font-weight': 400,
    'text-caption-1-font-weight': 400,
    'text-caption-2-font-weight': 400,
    'text-caption-3-font-weight': 400,
};
export const theme = {
    meta: {
        scope: 'all',
        parameters: {
            fontFamily: {
                type: 'string',
            },
            fontSize: {
                type: 'number',
            },
            fontWeight: {
                type: 'string',
            },
            color: {
                type: 'string',
            },
            colorDark: {
                type: 'string',
            }
        },
        appearances: {
            default: {
                default: true,
            },
            alternative: {
                default: false,
            },
            hint: {
                default: false,
            },
        },
        variantGroups: {
            category: {
                h1: {
                    default: false,
                },
                h2: {
                    default: false,
                },
                h3: {
                    default: false,
                },
                h4: {
                    default: false,
                },
                h5: {
                    default: false,
                },
                b1: {
                    default: true,
                },
                b2: {
                    default: false,
                },
                c1: {
                    default: false,
                },
                c2: {
                    default: false,
                },
                c3: {
                    default: false,
                },
                label: {
                    default: false,
                },
                caption: {
                    default: false,
                },
            },
            status: {
                primary: {
                    default: true
                },
                secondary: {
                    default: false
                },
                tertiary: {
                    default: false
                },
                subtle: {
                    default: false
                },
                brand: {
                    default: false
                },
                neutral: {
                    default: false
                },
                success: {
                    default: false
                },
                warning: {
                    default: false
                },
                danger: {
                    default: false
                },
            },
            bold: {
                default: false,
            },
        },
        states: {},
    },
    appearances: {
        default: {
            mapping: {
                color: 'text-basic-color',
            },
            variantGroups: {
                category: {
                    h1: {
                        fontSize: 'text-heading-1-font-size',
                        fontWeight: 'text-heading-1-font-weight',
                        fontFamily: 'text-heading-1-font-family',
                    },
                    h2: {
                        fontSize: 'text-heading-2-font-size',
                        fontWeight: 'text-heading-2-font-weight',
                        fontFamily: 'text-heading-2-font-family',
                    },
                    h3: {
                        fontSize: 'text-heading-3-font-size',
                        fontWeight: 'text-heading-3-font-weight',
                        fontFamily: 'text-heading-3-font-family',
                    },
                    h4: {
                        fontSize: 'text-heading-4-font-size',
                        fontWeight: 'text-heading-4-font-weight',
                        fontFamily: 'text-heading-4-font-family',
                    },
                    h5: {
                        fontSize: 'text-heading-5-font-size',
                        fontWeight: 'text-heading-5-font-weight',
                        fontFamily: 'text-heading-5-font-family',
                    },
                    h6: {
                        fontSize: 'text-heading-6-font-size',
                        fontWeight: 'text-heading-6-font-weight',
                        fontFamily: 'text-heading-6-font-family',
                    },
                    s1: {
                        fontSize: 'text-subtitle-1-font-size',
                        fontWeight: 'text-subtitle-1-font-weight',
                        fontFamily: 'text-subtitle-1-font-family',
                    },
                    s2: {
                        fontSize: 'text-subtitle-2-font-size',
                        fontWeight: 'text-subtitle-2-font-weight',
                        fontFamily: 'text-subtitle-2-font-family',
                    },
                    p1: {
                        fontSize: 'text-paragraph-1-font-size',
                        fontWeight: 'text-paragraph-1-font-weight',
                        fontFamily: 'text-paragraph-1-font-family',
                    },
                    p2: {
                        fontSize: 'text-paragraph-2-font-size',
                        fontWeight: 'text-paragraph-2-font-weight',
                        fontFamily: 'text-paragraph-2-font-family',
                    },
                    b1: {
                        fontSize: 'text-paragraph-1-font-size',
                        fontWeight: 'text-paragraph-1-font-weight',
                        fontFamily: 'text-paragraph-1-font-family',
                    },
                    b2: {
                        fontSize: 'text-paragraph-2-font-size',
                        fontWeight: 'text-paragraph-2-font-weight',
                        fontFamily: 'text-paragraph-2-font-family',
                    },
                    c1: {
                        fontSize: 'text-caption-1-font-size',
                        fontWeight: 'text-caption-1-font-weight',
                        fontFamily: 'text-caption-1-font-family',
                    },
                    c2: {
                        fontSize: 'text-caption-2-font-size',
                        fontWeight: 'text-caption-2-font-weight',
                        fontFamily: 'text-caption-2-font-family',
                    },
                    c3: {
                        fontSize: 'text-caption-3-font-size',
                        fontWeight: 'text-caption-3-font-weight',
                        fontFamily: 'text-caption-3-font-family',
                    },
                },
                status: {
                    primary: {
                        color: 'color-text-light-primary',
                        colorDark: 'color-text-dark-primary',
                    },
                    secondary: {
                        color: 'color-text-light-secondary',
                        colorDark: 'color-text-dark-secondary',
                    },
                    tertiary: {
                        color: 'color-text-light-tertiary',
                        colorDark: 'color-text-dark-tertiary'
                    },
                    subtle: {
                        color: 'color-text-light-subtle',
                        colorDark: 'color-text-dark-subtle',
                    },
                    brand: {
                        color: 'color-ui2-brand-500',
                        colorDark: 'color-ui2-brand-500',
                    },
                    neutral: {
                        color: 'color-ui2-neutral-500',
                        colorDark: 'color-ui2-neutral-500',
                    },
                    success: {
                        color: 'color-ui2-success-500',
                        colorDark: 'color-ui2-success-500',
                    },
                    warning: {
                        color: 'color-ui2-warning-500',
                        colorDark: 'color-ui2-warning-500',
                    },
                    danger: {
                        color: 'color-ui2-danger-500',
                        colorDark: 'color-ui2-danger-500',
                    },
                },
            },
        },
        alternative: {
            mapping: {
                color: 'text-alternate-color',
            },
        },
        hint: {
            mapping: {
                color: 'text-hint-color',
            },
        },
    },
};
export default {
    tokens,
    theme,
};
//# sourceMappingURL=DNAText.theme.alucio.js.map